import React, { useState } from 'react';

import {
  Box,
  Text,
  Input,
  FormControl,
  FormLabel,
  VStack,
  InputGroup,
  InputLeftAddon,
  HStack,
} from '@chakra-ui/react';

import { useColors } from './colors';

const ListingInventory = ({ listing, onUpdate }) => {
  const [price, setPrice] = useState(listing?.details?.price || '');
  const [quantity, setQuantity] = useState(listing?.details?.quantity || '');
  const [minPrice, setMinPrice] = useState(
    listing?.marketplaceDetails?.priceOptions?.minimum || '',
  );
  const [maxPrice, setMaxPrice] = useState(
    listing?.marketplaceDetails?.priceOptions?.maximum || '',
  );

  const {
    bgColor,
    borderColor,
    headingColor,
    subTextColor: labelColor,
    inputColor,
    placeholderColor,
    hoverBg: readOnlyBg,
  } = useColors();

  const readOnlyColor = inputColor;

  const isAmazon = listing?.marketplace?.name?.toLowerCase() === 'amazon';

  const handlePriceChange = (e) => {
    const newPrice = e.target.value;
    setPrice(newPrice);

    // Auto-calculate min and max prices for Amazon
    if (isAmazon && newPrice) {
      const priceNum = parseFloat(newPrice);
      if (!isNaN(priceNum)) {
        const newMinPrice = (priceNum * 0.95).toFixed(2);
        const newMaxPrice = (priceNum * 1.15).toFixed(2);
        setMinPrice(newMinPrice);
        setMaxPrice(newMaxPrice);
        onUpdate?.({ price: newPrice, minPrice: newMinPrice, maxPrice: newMaxPrice });
      } else {
        onUpdate?.({ price: newPrice });
      }
    } else {
      onUpdate?.({ price: newPrice });
    }
  };

  const handleQuantityChange = (e) => {
    const newQuantity = e.target.value;
    setQuantity(newQuantity);
    onUpdate?.({ quantity: newQuantity });
  };

  const handleMinPriceChange = (e) => {
    const newMinPrice = e.target.value;
    setMinPrice(newMinPrice);
    onUpdate?.({ minPrice: newMinPrice });
  };

  const handleMaxPriceChange = (e) => {
    const newMaxPrice = e.target.value;
    setMaxPrice(newMaxPrice);
    onUpdate?.({ maxPrice: newMaxPrice });
  };

  return (
    <Box
      bg={bgColor}
      borderRadius="xl"
      p={6}
      border="1px solid"
      borderColor={borderColor}
      w="100%"
    >
      <Text fontSize="xl" fontWeight="semibold" color={headingColor} mb={6}>
        Listing Inventory
      </Text>

      <VStack spacing={5} align="stretch">
        <HStack spacing={5} align="stretch">
          <FormControl>
            <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
              Price
            </FormLabel>
            <InputGroup>
              <InputLeftAddon children="$" />
              <Input
                value={price}
                onChange={handlePriceChange}
                placeholder="0.00"
                type="number"
                step="0.01"
                min="0"
                size="md"
                borderRadius="md"
                _focus={{
                  borderColor: 'blue.400',
                  boxShadow: '0 0 0 1px #3182ce',
                }}
                color={inputColor}
                _placeholder={{ color: placeholderColor }}
              />
            </InputGroup>
          </FormControl>
          <FormControl>
            <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
              Quantity
            </FormLabel>
            <InputGroup>
              <InputLeftAddon children="#" />
              <Input
                value={quantity}
                onChange={handleQuantityChange}
                placeholder="0"
                type="number"
                min="0"
                size="md"
                borderRadius="md"
                _focus={{
                  borderColor: 'blue.400',
                  boxShadow: '0 0 0 1px #3182ce',
                }}
                color={inputColor}
                _placeholder={{ color: placeholderColor }}
              />
            </InputGroup>
          </FormControl>
        </HStack>

        {/* Amazon-only fields */}
        {isAmazon && (
          <HStack spacing={5} align="stretch">
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
                Min Price
              </FormLabel>
              <InputGroup>
                <InputLeftAddon children="$" />
                <Input
                  value={minPrice}
                  onChange={handleMinPriceChange}
                  placeholder="0.00"
                  type="number"
                  step="0.01"
                  min="0"
                  size="md"
                  borderRadius="md"
                  _focus={{
                    borderColor: 'blue.400',
                    boxShadow: '0 0 0 1px #3182ce',
                  }}
                  color={inputColor}
                  _placeholder={{ color: placeholderColor }}
                />
              </InputGroup>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
                Max Price
              </FormLabel>
              <InputGroup>
                <InputLeftAddon children="$" />
                <Input
                  value={maxPrice}
                  onChange={handleMaxPriceChange}
                  placeholder="0.00"
                  type="number"
                  step="0.01"
                  min="0"
                  size="md"
                  borderRadius="md"
                  _focus={{
                    borderColor: 'blue.400',
                    boxShadow: '0 0 0 1px #3182ce',
                  }}
                  color={inputColor}
                  _placeholder={{ color: placeholderColor }}
                />
              </InputGroup>
            </FormControl>
          </HStack>
        )}
      </VStack>
    </Box>
  );
};

export default ListingInventory;
